import { Action } from '@ngrx/store';
import { SearchParams } from '../../../shared/models/b2b/searchParams';

export enum SearchActionTypes {
    DO_GET_INFO_PRODUCTS = '[Search] Get Info Products',
    DO_GET_INFO_PRODUCTS_OK = '[Search] Get Info Products OK',
    DO_GET_INFO_PRODUCTS_KO = '[Search] Get Info Products KO',
    DO_SET_SEARCH_PARAMS = '[Search] Set Search Params',
    DO_CLEAR_SEARCH = '[Search] Clear Search',
    DO_CLEAR_PRODUCTS = '[Search] Clear Products',
    DO_SET_FORM_SUBMIT_ATTEMPT = '[Search] Set Form Submit Attempt',
    DO_CANCEL_GET_INFO_PRODUCTS = '[Search] Cancel Get Info Products',
    DO_SET_SEARCH_PARTS = '[Search] Set search parts',
    DO_SET_LOADING = '[Search] Update loading',
}

// Search Results
export class DoGetInfoProducts implements Action {
    readonly type = SearchActionTypes.DO_GET_INFO_PRODUCTS;

    constructor(public payload: any) {}
}

export class DoCancelGetInfoProducts implements Action {
    readonly type = SearchActionTypes.DO_CANCEL_GET_INFO_PRODUCTS;

    constructor() {}
}

export class DoGetInfoProductsOK implements Action {
    readonly type = SearchActionTypes.DO_GET_INFO_PRODUCTS_OK;

    constructor(public payload: any) {}
}

export class DoGetInfoProductsKO implements Action {
    readonly type = SearchActionTypes.DO_GET_INFO_PRODUCTS_KO;

    constructor(public payload: any) {}
}

// Set Search Params
export class DoSetSearchParams implements Action {
    readonly type = SearchActionTypes.DO_SET_SEARCH_PARAMS;

    constructor(public payload: SearchParams) {}
}

// Set Form Submit Attempt
export class DoSetFormSubmitAttempt implements Action {
    readonly type = SearchActionTypes.DO_SET_FORM_SUBMIT_ATTEMPT;

    constructor(public payload: boolean) {}
}

// Clear Search
export class DoClearSearch implements Action {
    readonly type = SearchActionTypes.DO_CLEAR_SEARCH;

    constructor() {}
}

// Clear Products
export class DoClearProducts implements Action {
    readonly type = SearchActionTypes.DO_CLEAR_PRODUCTS;

    constructor() {}
}

// Set search parts
export class DoSetSearchParts implements Action {
    readonly type = SearchActionTypes.DO_SET_SEARCH_PARTS;

    constructor(public payload: boolean) {}
}

export class DoSetLoading implements Action {
    readonly type = SearchActionTypes.DO_SET_LOADING;

    constructor(public payload: boolean) {}
}

export type SearchActions =
    | DoGetInfoProducts
    | DoGetInfoProductsOK
    | DoGetInfoProductsKO
    | DoSetSearchParams
    | DoSetFormSubmitAttempt
    | DoClearSearch
    | DoClearProducts
    | DoCancelGetInfoProducts
    | DoSetSearchParts
    | DoSetLoading;
